module.exports = __webpack_public_path__ + "img/question-icon.d0656e9e.png";